"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupCompaniesSwaggerMetadata = exports.getCompanyDetailsSwaggerMetadata = exports.getCompaniesDataSwaggerMetadata = exports.getCompanyListSwaggerMetadata = exports.updateCompanySwaggerMetadata = exports.getCompaniesSwaggerMetadata = exports.deleteCompanySwaggerMetadata = exports.getCompanySwaggerMetadata = void 0;
exports.createCompanySwaggerMetadata = createCompanySwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const company_detail_dto_1 = require("./dto/company-detail.dto");
const company_dto_1 = require("./dto/company.dto");
const create_company_dto_1 = require("./dto/create-company.dto");
const get_company_list_dto_1 = require("./dto/get-company-list-dto");
const update_company_dto_1 = require("./dto/update-company.dto");
const company_response_dto_1 = require("./dto/company-response.dto");
// Swagger metadata for the createCompany method
function createCompanySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_company_dto_1.CreateCompanyDto, company_detail_dto_1.CompanyDetailsDto, company_response_dto_1.CompanyResponseDto), (0, swagger_1.ApiOperation)({
        summary: "Create Company",
        description: 'Creates a company along with its addresses, and details. Requires authentication and "BD" role.',
    }), (0, swagger_1.ApiBody)({
        description: "Company creation payload",
        schema: {
            type: "object",
            properties: {
                company: {
                    $ref: (0, swagger_1.getSchemaPath)(create_company_dto_1.CreateCompanyDto),
                },
                companyDetails: {
                    $ref: (0, swagger_1.getSchemaPath)(company_detail_dto_1.CompanyDetailsDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.companyCreated,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: { type: "string", example: messages_1.successMessage.companyCreated },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(company_response_dto_1.CompanyResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Unauthorized - Invalid or missing authentication token",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 401 },
                message: { type: "string", example: "Unauthorized" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 403,
        description: "Forbidden - User does not have the required role",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 403 },
                message: {
                    type: "string",
                    example: "Access denied. User doesn't have permission.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Invalid input data" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
}
// Swagger metadata for the getCompany method
const getCompanySwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get company data with all the related entities by ID",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the company",
        type: String,
    }), (0, swagger_1.ApiExtraModels)(company_response_dto_1.CompanyResponseDto), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.companyDetails,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.companyDetails },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(company_response_dto_1.CompanyResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.companyNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.companyNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.getCompanySwaggerMetadata = getCompanySwaggerMetadata;
// Swagger metadata for the deleteCompany method
const deleteCompanySwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Delete company by ID" }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the company to delete",
        type: String,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    (0, swagger_1.ApiResponse)({ status: 200, description: "Company deleted successfully" }), (0, swagger_1.ApiResponse)({ status: 404, description: "Company not found" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.deleteCompanySwaggerMetadata = deleteCompanySwaggerMetadata;
// Swagger metadata for the listCompanies method
const getCompaniesSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    (0, swagger_1.ApiOperation)({
        summary: "Retrieve a paginated list of companies",
        description: "Retrieves a paginated list of companies with optional filters and sorting.",
    }), ...Object.keys(get_company_list_dto_1.GetCompaniesDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompaniesDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompaniesDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.companyListRetrieved,
        type: company_dto_1.CompanyListResponseDto,
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.getCompaniesSwaggerMetadata = getCompaniesSwaggerMetadata;
// Swagger metadata for the updateCompany method
const updateCompanySwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update Company",
        description: "Updates a company's details, addresses, GST details, group company mappings, and document mappings. Requires authentication and 'BD' role.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(update_company_dto_1.UpdateCompanyDto, company_detail_dto_1.CompanyDetailsDto, company_response_dto_1.CompanyResponseDto), (0, swagger_1.ApiParam)({
        name: "companyId",
        description: "The ID of the company to update",
        type: String,
    }), (0, swagger_1.ApiBody)({
        description: "Company update payload",
        schema: {
            type: "object",
            properties: {
                company: {
                    $ref: (0, swagger_1.getSchemaPath)(update_company_dto_1.UpdateCompanyDto),
                },
                companyDetails: {
                    $ref: (0, swagger_1.getSchemaPath)(company_detail_dto_1.CompanyDetailsDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.companyUpdated,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.companyUpdated },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(company_response_dto_1.CompanyResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.companyNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.companyNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.updateCompanySwaggerMetadata = updateCompanySwaggerMetadata;
const getCompanyListSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a paginated list of companies with id, name and country",
        description: "Returns a paginated list of companies. Supports optional search on displayName and companyName. Requires authentication and 'BD' role.",
    }), (0, swagger_1.ApiExtraModels)(get_company_list_dto_1.GetCompanyListDto, company_dto_1.CompanyListResponseDto), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    ...Object.keys(get_company_list_dto_1.GetCompanyListDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompanyListDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompanyListDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.companyListRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.companyListRetrieved,
                },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1 },
                                    companyName: { type: "string", example: "TechCorp" },
                                    displayName: {
                                        type: "string",
                                        example: "Tech Corporation",
                                    },
                                    companyType: { type: "string", example: "Private" },
                                    status: { type: "string", example: "Active" },
                                    groupCompany: { type: "string", example: "Tech Group" },
                                },
                            },
                        },
                        count: { type: "number", example: 100 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.companyListNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.companyListNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Unauthorized - Invalid or missing authentication token",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 401 },
                message: { type: "string", example: "Unauthorized" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 403,
        description: "Forbidden - User does not have the required role",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 403 },
                message: {
                    type: "string",
                    example: "Access denied. User doesn't have permission.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.getCompanyListSwaggerMetadata = getCompanyListSwaggerMetadata;
const getCompaniesDataSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a paginated list of companies with id, name and its associated companies",
        description: "Fetches a paginated list of companies with optional search functionality. Requires authentication and 'BD' role.",
    }), (0, swagger_1.ApiExtraModels)(get_company_list_dto_1.GetCompanyListDto), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    ...Object.keys(get_company_list_dto_1.GetCompanyListDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompanyListDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompanyListDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.companyListRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.companyListRetrieved,
                },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1 },
                                    companyName: { type: "string", example: "TechCorp test" },
                                    childCompanies: {
                                        type: "array",
                                        items: {
                                            type: "object",
                                            properties: {
                                                id: { type: "number", example: 2 },
                                                companyName: { type: "string", example: "TechCorp " },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                        count: { type: "number", example: 100 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.companyListNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.companyListNotFound,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Unauthorized - Invalid or missing authentication token",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 401 },
                message: { type: "string", example: "Unauthorized" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 403,
        description: "Forbidden - User does not have the required role",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 403 },
                message: {
                    type: "string",
                    example: "Access denied. User doesn't have permission.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.getCompaniesDataSwaggerMetadata = getCompaniesDataSwaggerMetadata;
const getCompanyDetailsSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({ summary: "Get company details by ID" }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "The ID of the company to retrieve details",
        type: String,
    }), (0, swagger_1.ApiQuery)({
        name: "contactId",
        description: "The ID of the contact to exclude from the response",
        type: Number,
        required: false,
    }), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Company details retrieved successfully",
        schema: {
            example: {
                status: 200,
                message: "Company retrieved successfully",
                data: [
                    {
                        id: 143,
                        companyName: "hhh",
                        displayName: "RLGK",
                        companyAddresses: [
                            {
                                id: 1,
                                address1: "testing Contact Details",
                                cityId: {
                                    id: 1,
                                    name: "Visakhapatnam",
                                },
                            },
                        ],
                        contacts: [
                            {
                                id: 156,
                                firstName: "testing",
                                lastName: "Contact",
                                middleName: "testing Contact Details",
                                displayName: "testing Contact Details",
                            },
                        ],
                    },
                ],
            },
        },
    }), (0, swagger_1.ApiResponse)({ status: 404, description: "Company not found" }), (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error" }));
};
exports.getCompanyDetailsSwaggerMetadata = getCompanyDetailsSwaggerMetadata;
const getGroupCompaniesSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Retrieve a paginated list of group companies with id, name",
        description: "Fetches a paginated list of group companies with optional search functionality. Requires authentication and 'BD' role.",
    }), (0, swagger_1.ApiExtraModels)(get_company_list_dto_1.GetCompanyListDto, company_dto_1.CompanyListResponseDto), (0, swagger_1.ApiBearerAuth)("access-token"), // Indicates that the endpoint requires a Bearer token for authentication
    ...Object.keys(get_company_list_dto_1.GetCompanyListDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompanyListDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_company_list_dto_1.GetCompanyListDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.groupCompanyListRetrieved,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.groupCompanyListRetrieved,
                },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1 },
                                    companyName: { type: "string", example: "TechCorp" },
                                    displayName: {
                                        type: "string",
                                        example: "Tech Corporation",
                                    },
                                    country: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "India" },
                                            isoCode: { type: "string", example: null },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                },
                            },
                        },
                        count: { type: "number", example: 100 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.groupCompanyListRetrievalFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.groupCompanyListRetrievalFailed,
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 401,
        description: "Unauthorized - Invalid or missing authentication token",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 401 },
                message: { type: "string", example: "Unauthorized" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 403,
        description: "Forbidden - User does not have the required role",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 403 },
                message: {
                    type: "string",
                    example: "Access denied. User doesn't have permission.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error" },
            },
        },
    }));
};
exports.getGroupCompaniesSwaggerMetadata = getGroupCompaniesSwaggerMetadata;
